<template lang="" >
    <div>
        <div @click="closeKeypad" class="backdrop"></div>
        <b-container class="position-absolute bg-white" id="keypad">

            <div class="d-flex align-items-center header-row">
                <div class="avatar-circle mr-3">
                    <img
                        v-if="picUrl"
                        :src="$config.files.baseurlimage + picUrl"
                        class="avatar-img"
                    />
                    <font-awesome-icon v-else icon="user" />
                </div>
                <div class="text-left">
                    <div class="title">User login</div>
                    <div class="enter-pas-text">Enter passcode to continue</div>
                </div>
            </div>

            <div class="code-row">
                <div class="error text-center font-weight-bold" v-if="error">
                    Invalid passcode. Please try again
                </div>
                <div class="code-boxes" v-else>
                    <div class="code-box" v-for="n in 6" :key="n">
                        <span v-if="codeToBeDisplayed.length >= n">&#9679;</span>
                    </div>
                </div>
            </div>

            <b-row>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="addDigit(1)">1</b-button>
                </b-col>
                <b-col >
                    <b-button class="keypad-btns" v-on:click="addDigit(2)">2</b-button>
                </b-col>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="addDigit(3)">3</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="addDigit(4)">4</b-button>
                </b-col>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="addDigit(5)">5</b-button>
                </b-col>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="addDigit(6)">6</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="addDigit(7)">7</b-button>
                </b-col>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="addDigit(8)">8</b-button>
                </b-col>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="addDigit(9)">9</b-button>
                </b-col>    
            </b-row>
            <b-row>
                <b-col>
                    <b-button class="keypad-btns clear-btn" v-on:click="clearCode()">Clear</b-button>
                </b-col>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="addDigit(0)">0</b-button>
                </b-col>
                <b-col>
                    <b-button class="keypad-btns" v-on:click="deleteDigit()"><font-awesome-icon icon="backspace" /></b-button>
                </b-col>
            </b-row>

            <b-container fluid class="px-0">
                <button type="button" v-on:click="submitPin" :disabled="progressing" class="submit-btn">Submit <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/></button>
                <b-link v-on:click="logout" class="system-logout d-block text-center">Log out to use username instead</b-link>
            </b-container>

        </b-container>
    </div>
</template>
<script>
import * as types from '@/store/types'

export default {
    name:"SwitchAccountKeypad",

    props: {
        picUrl: {
            required: false,
            default: null
        }
    },

    data() {
        return {
            enteredCode:"",
            codeToBeDisplayed:"",
            error:false,
            progressing:false,
        }
    },
    
    methods:{
        addDigit(digit){
            if(this.enteredCode.length < 6){
                this.error =false
                this.enteredCode+= digit;
                this.codeToBeDisplayed += "*"
            }
            
        },
        deleteDigit(){
            this.enteredCode = this.enteredCode.slice(0, -1);
            this.codeToBeDisplayed = this.codeToBeDisplayed.slice(0, -1);
            this.error = false
        },
        clearCode(){
            this.enteredCode= '';
            this.codeToBeDisplayed = '';
            this.error = false
        },
        submitPin(){
            if(this.enteredCode.length === 6){
                this.progressing = true
                this.error = false

                const model={
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    Pin: this.enteredCode    
                }
                this.progressing = true
                this.$api.user.SwitchUser(model,true).then(user=>{
                    
                    if(user.message != "Invalid Pin"){
                        
                        

                       
                        this.$store.commit(types.SET_ACCOUNT, user)
                        localStorage.setItem("requirePin", false)
                        window.location.href = window.location.origin + '/todayOrders/index';

                        
                    }else{
                        this.error = true
                        this.enteredCode = ""
                        this.codeToBeDisplayed = ""
                    }
                    
                }).catch(()=>{
                    this.error = true
                })
            }else
                this.error = true
            this.progressing = false
        },
        closeKeypad(){
            if(this.noOverride)
                return
            
            this.$emit("closeSwitchAccountKeypad")//account.vue
        },
        logout () {
                this.loading = true
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    UserID: localStorage.getItem('userID')
                }
                if(model.UserID === null){//we changed from userid based auth to header based if userid is null we req for it here first
                    return this.$api.getRestaurant.getList().then(res=>{
                        model.UserID = res.results.UserID
                        this.$api.getRestaurant.GetLogOut(model).then(res => {
                            if (res.success) {
                                this.loading = false
                                localStorage.clear()
                                sessionStorage.clear()
                                localStorage.setItem("requirePin", false)
                                this.$router.push('/')
                                // window.location.assign(`${config.redirectToHome}/?auth=0`)
                            } else {
                                this.loading = false
                                this.$showError(res.message)
                            }
                        }).catch(() => {
                            this.loading = false
                        })
                    })
                }

                
                this.$api.getRestaurant.GetLogOut(model).then(res => {
                    if (res.success) {
                        this.loading = false
                        localStorage.clear()
                        sessionStorage.clear()
                        this.$router.push('/')
                        // window.location.assign(`${config.redirectToHome}/?auth=0`)
                    } else {
                        this.loading = false
                        this.$showError(res.message)
                    }
                }).catch(() => {
                    this.loading = false
                })
            }
    }
}
</script>
<style lang="css" scoped>
    .backdrop{
        position: absolute;
        top: 0;
        left: 0;
        width:100vw;
        height:100vh;
        z-index: 999;
        background: grey;
        opacity: 0.55;
    }
    #keypad{
        top: 10vh;
        left:calc(50% - 12.5rem);
        width: 25rem;
        border-radius: 1rem;
        box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.25);
        z-index: 1000;
        opacity: 1!important;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 1.5rem 1.25rem;
    }
    .header-row{
        margin-bottom: 1.25rem;
    }
    .avatar-circle{
        width: 2.75rem;
        height: 2.75rem;
        min-width: 2.75rem;
        border-radius: 50%;
        background-color: #cfe3fb;
        color: #4a7fc9;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.1rem;
        overflow: hidden;
    }
    .avatar-img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .title{
        font-weight: bold;
        font-size: 1.1rem;
        line-height: 1.3;
    }
    .enter-pas-text{
        color: #8a8f98;
        font-size: 0.9rem;
    }
    .code-row{
        margin-bottom: 1.25rem;
    }
    .code-boxes{
        display: flex;
        justify-content: center;
        gap: 0.6rem;
    }
    .code-box{
        width: 2.4rem;
        height: 2.4rem;
        border: 1px solid #dfe3e8;
        border-radius: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.9rem;
        color: #2b2f38;
        background-color: #fff;
    }
    .error{
        color: #e02020;
        font-size: 0.95rem;
    }
    .col{
        padding: 0.35rem;
    }
    .keypad-btns{
        margin: 0;
        width: 100%;
        height: 3.75rem;
        background-color: #fafbfc;
        border: 1px solid #e5e8ec;
        border-radius: 0.6rem;
        font-weight: 600;
        font-size: 1.3rem;
        color: #2b2f38;
    }
    .keypad-btns:hover{
        background-color: #f0f2f5;
    }
    .keypad-btns:focus,.clear-btn:focus{
        color: #2b2f38;
        box-shadow: none;
    }
    .clear-btn{
        font-size: 0.95rem;
        font-weight: 600;
    }
    .submit-btn{
        background-color: #FFC90E;
        border-radius: 0.6rem;
        font-weight: bold;
        font-size: 1.15rem;
        border: none;
        width: 100%;
        height: 3rem;
        margin-top: 1rem;
    }
    .system-logout{
        margin-top: 1rem;
        font-size: 0.9rem;
    }
    @media (max-width: 768px) {
        #keypad{
            top: 10vh;
            left:calc(50% - 10rem);
            width: 20rem;
            padding: 1.25rem 1rem;
        }
        .keypad-btns{
            height: 3.25rem;
            font-size: 1.1rem;
        }
        .submit-btn{
            font-size: 1rem;
            height: 2.75rem;
        }
        .system-logout{
            font-size: 0.8rem;
        }
    } 
</style>